<script setup lang="ts">
import SiteHeader from '@components/layout/site-header';
import SiteFooter from '@components/layout/site-footer/SiteFooter.vue';
defineProps<{
    footer?: boolean;
}>();
const { isMrbilit } = useWhiteLabel();
const { y } = useWindowScroll();
</script>

<template>
    <div ref="el">
        <SiteHeader
            overlay-header
            desktop-color="blue"
            menu-color="white"
            sticky-in-mobile
            class="header-container"
            :class="{ scrolled: y > 20 }"
        />
        <slot />
        <VitePwaManifest v-if="isMrbilit" />
        <SiteFooter v-if="footer" />
    </div>
</template>
<style lang="scss" scoped>
.header-container {
    &.scrolled {
        @include mobile-only {
            :deep(.sticky) {
                -webkit-transition: background-color 1000ms linear;
                -ms-transition: background-color 1000ms linear;
                transition: background-color 100ms linear;
                background-color: usePalette($p-blue);
            }
        }
    }
    :deep() {
        @include mobile-only {
            .close-button-container {
                .mr-button {
                    &.filled {
                        background: none !important;
                    }
                }
            }
        }
        @include desktop-only {
            padding-bottom: 70px;
            background-color: white;
            .user-position:hover {
                .body {
                    .title,
                    svg {
                        color: white !important;
                    }
                }
                .edit-user-icon {
                    svg {
                        color: white !important;
                    }
                }
            }
        }
        a:hover {
            &.body {
                color: white !important;
            }
        }
    }
}
</style>
